import {
	GET_INCIDENT_CONFIGURATIONS,
	TOGGLE_INC_CONFIG_DIALOG,
	SELECT_INC_CONFIGURATION,
	SET_FORM_STATE,
} from '../actions/IncidentTrackerConfigurationActions';

const initialState = {
	incidentConfigurations: {},
	selectedConfiguration: { category: '', item: {} },
	incConfigDialogVisibility: false,
	incConfigDialogMode: '',
	formState: {
		isValid: false,
		values: {},
		touched: {},
		errors: {},
	},
};

const incidentTrackerConfigurationReducer = (state = initialState, action) => {
	switch (action.type) {
					case GET_INCIDENT_CONFIGURATIONS: {
						return {
							...state,
							incidentConfigurations: action.incidentConfigurations,
						};
					}
					case TOGGLE_INC_CONFIG_DIALOG: {
						return {
							...state,
							incConfigDialogVisibility: action.visible,
							incConfigDialogMode: action.mode
						};
					}
					case SELECT_INC_CONFIGURATION: {
						return {
							...state,
							selectedConfiguration: action.selectedConfiguration
						};
					}
					case SET_FORM_STATE: {
						return {
							...state,
							formState: action.formState
						};
					}
					default: {
						return state;
					}
	}
};

export default incidentTrackerConfigurationReducer;
